import React from 'react';
import Facebook from './SocialIconsSVG/Facebook';
import Instagram from './SocialIconsSVG/Instagram';
import Linkedin from './SocialIconsSVG/Linkedin';
import Whatsapp from './SocialIconsSVG/Whatsapp';

const SelectSocialIcon = (props) => {
  const { iconName, origin } = props;

  let Icon;
  if (iconName === 'instagram') {
    Icon = <Instagram color="#FFF" />;
  } else if (iconName === 'facebook') {
    Icon = <Facebook color="#FFF" />;
  } else if (iconName === 'linkedin') {
    Icon = <Linkedin color="#FFF" />;
  } else if (iconName === 'whatsapp') {
    Icon = <Whatsapp color="#FFF" origin={origin} />;
  }
  return Icon;
};

export default SelectSocialIcon;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SocialIcons.jsx